import React from "react";
import {
    Routes,
    Route,
    Navigate,
    useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Topbar from "components/navbar/Topbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes";
import SupportWidget from "components/support/SupportWidget";
import BackOfficeNavigation from "components/admin/BackOfficeNavigation";

export default function Admin(props: { [x: string]: any }) {
    const location = useLocation();
    const isBackOffice =
        location.pathname === "/bo" ||
        location.pathname.startsWith("/bo/") ||
        location.pathname === "/bo-commercial" ||
        location.pathname.startsWith("/bo-commercial/");
    const [open, setOpen] = React.useState(true);
    const fullSidebar = true;
    const [currentRoute, setCurrentRoute] = React.useState("");

    React.useEffect(() => {
        window.innerWidth < 1024 ? setOpen(false) : setOpen(true);
        window.addEventListener("resize", () => {
            window.innerWidth < 1024 ? setOpen(false) : setOpen(true);
        });
    }, []);

    React.useEffect(() => {
        if (localStorage.getItem("token") === null) {
            window.location.href = "/auth/login";
        }
        getActiveRoute(routes);
        // eslint-disable-next-line
    }, [location.pathname]);

    const getActiveRoute = (routes: RoutesType[]): string => {
        let activeRoute = "Dashboard";
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse) {
                let collapseActiveRoute = getActiveRoute(routes[i].items);
                if (collapseActiveRoute !== activeRoute) {
                    return collapseActiveRoute;
                }
            } else {
                if (
                    window.location.href.indexOf(
                        routes[i].layout + routes[i].path,
                    ) !== -1
                ) {
                    setCurrentRoute(routes[i].name);
                }
            }
        }
        return activeRoute;
    };
    const getRoutes = (routes: RoutesType[]): any => {
        return routes.map((prop, key) => {
            if (prop.layout === "/admin" || prop.layout === "") {
                return (
                    <Route
                        path={`${prop.path}`}
                        element={prop.component}
                        key={key}
                    />
                );
            }
            if (prop.collapse) {
                return getRoutes(prop.items);
            }
            return null;
        });
    };
    
    document.documentElement.dir = "ltr";
    
    return (
        <div className="flex flex-col h-screen bg-canvas">
            {isBackOffice ? (
                <BackOfficeNavigation />
            ) : (
                <Topbar
                    brandText={currentRoute}
                    onOpenSidenav={() => setOpen(!open)}
                />
            )}
            
            <div className={`flex flex-1 overflow-hidden ${isBackOffice ? "min-h-0" : ""}`}>
                {/* Mobile overlay */}
                {!isBackOffice && open && (
                    <div
                        className="fixed inset-0 bg-black/50 z-30 xl:hidden"
                        onClick={() => setOpen(false)}
                    />
                )}
                
                {/* Sidebar */}
                {!isBackOffice && (
                    <Sidebar
                        open={open}
                        fullSidebar={fullSidebar}
                        onClose={() => setOpen(false)}
                    />
                )}
                
                {/* Main content */}
                <main className={`flex-1 overflow-y-auto transition-all duration-300 ${
                    isBackOffice ? "bg-[#f5f7fb]" : `pr-8 ${fullSidebar ? "xl:ml-[7.75rem]" : "xl:ml-0"}`
                }`}>
                    <ToastContainer />
                    <div className={isBackOffice ? "min-h-full" : "px-8 pt-6 pb-8 pr-0"}>
                        <Routes>
                            {getRoutes(routes)}
                            <Route
                                path="/"
                                element={<Navigate to="/dashboard" replace />}
                            />
                        </Routes>
                    </div>
                    {!isBackOffice && (
                        <div className="px-8 pb-4 pr-0">
                            <Footer />
                        </div>
                    )}
                </main>
            </div>
            
            {/* Support chat — tickets in /bo/support */}
            {!isBackOffice && <SupportWidget />}
        </div>
    );
}
